'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _Overlay = require('react-bootstrap/lib/Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var PopoverMenu = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PopoverMenu, _Component);

  function PopoverMenu() {
    var _ref;

    (0, _classCallCheck3.default)(this, PopoverMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverMenu.__proto__ || (0, _getPrototypeOf2.default)(PopoverMenu)).call.apply(_ref, [this].concat(args)));

    _this.onResize = function () {
      _this.hide();
    };

    _this.state = {
      show: false,
      container: _this
    };
    _this.data = null;
    return _this;
  }

  (0, _createClass3.default)(PopoverMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.onResize);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.show !== this.props.show) {
        this.setState({ show: nextProps.show });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize);
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.setState({
        show: false,
        data: null
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e, newData) {
      var _this2 = this;

      e.preventDefault();
      e.stopPropagation();
      var newTarget = e.target;
      var _state = this.state,
          target = _state.target,
          show = _state.show;


      if (newTarget === target && show) {
        this.hide();
      } else {
        setTimeout(function () {
          var newShow = newData === _this2.data ? !show : true;
          _this2.data = newShow ? newData : null;
          _this2.setState({
            show: newShow,
            target: newTarget,
            container: _this2,
            containerPadding: 10
          });
        }, 0);
      }
    }

    // TODO: refactor popovers for eslint
    /* eslint-disable react/no-find-dom-node */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          id = _props.id,
          className = _props.className;
      var _state2 = this.state,
          _target = _state2.target,
          props = (0, _objectWithoutProperties3.default)(_state2, ['target']);


      return _react2.default.createElement(
        _Overlay2.default,
        (0, _extends3.default)({
          target: function target() {
            return (0, _reactDom.findDOMNode)(_target);
          },
          placement: 'bottom',
          rootClose: true,
          onHide: this.hide
        }, props),
        _react2.default.createElement(
          _Popover2.default,
          { id: id },
          _react2.default.createElement(
            'ul',
            { className: (0, _classnames2.default)('popoverMenu', className), onClick: this.hide },
            children
          )
        )
      );
    }
    /* eslint-enable react/no-find-dom-node */

  }]);
  return PopoverMenu;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  className: _propTypes2.default.string,
  id: _propTypes2.default.string.isRequired,
  show: _propTypes2.default.bool
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hide'), _class.prototype)), _class);
exports.default = PopoverMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PopoverMenu/PopoverMenu.js
// module id = 258
// module chunks = 1